import { useBehavior } from '@libs/hooks';
import { TCommonData, TWidgetProps } from '@libs/types';
import React, { Activity } from 'react';
import { TTextOption } from '../../types/options';
import { TextCommon } from '../UI/Text/TextCommon';

declare const VERSION: string;

export const AppVersion: React.FC<TWidgetProps<TCommonData, TTextOption>> = ({ widget }) => {
    const { isHidden } = useBehavior(widget);
    const options = widget.options ?? {};

    return (
        <Activity mode={isHidden ? 'hidden' : 'visible'}>
            <TextCommon isWidget={false} uid={widget.uid} as={'p'} options={{ ...options, textColor: options.textColor ?? 'grey_72_lc' }}>
                {`Web · ${VERSION}`}
            </TextCommon>
        </Activity>
    );
};
